import { useEffect } from "react";
import { useRouter } from "next/router";

export const useAutoCloseMenu = (closeMenu: () => void) => {
    const router = useRouter();

    useEffect(() => {
        router.events.on("routeChangeStart", closeMenu);

        // If the component is unmounted, unsubscribe
        // from the event with the `off` method:
        return () => {
            router.events.off("routeChangeStart", closeMenu);
        };
    }, [router, closeMenu]);
};
